import React, { useCallback, useMemo } from 'react';
import { useAuth } from '@/app/providers/AuthProvider';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import FormConstructor from '@/common/containers/FormConstructor/index';
import Loader from '@/common/components/Loader/index';
import { useQuestionListQuery } from '@/entities/question';

const DISABLED_BY_CHECKBOX = [
  'firstName',
  'lastName',
  'middleName',
  'email',
  'telH',
  'telM',
];

const USER_FIELD_DEP = {
  firstName: 'firstName',
  lastName: 'lastName',
  middleName: 'middleName',
  email: 'email',
  telH: 'homePhoneNumber',
  telM: 'mobilePhoneNumber',
};

const LegalTasks = ({ onSubmit, ...props }) => {
  const decedentId = useCurrentDecedentId();
  const { user = {} } = useAuth();
  const questionListQuery = useQuestionListQuery('legal', decedentId);
  const payload = useMemo(() => {
    if (!questionListQuery.data) {
      return {};
    }

    const { list, answers } = questionListQuery.data;
    const formatted = {
      questions: list[0].questions,
      answers,
    };

    if (formatted.questions.length) {
      formatted.questions[0].answerOptions.properties =
        formatted.questions[0].answerOptions.properties.map((item) =>
          DISABLED_BY_CHECKBOX.includes(item.key)
            ? {
                ...item,
                disabled: (name, { watch }) => {
                  const [slug] = name.split('.');
                  const value = watch(`${slug}.value.sameAsPrimaryUser`);
                  return value;
                },
              }
            : item
        );
    }

    return formatted;
  }, [questionListQuery.data]);
  const formKey = String(questionListQuery.dataUpdatedAt || '1');
  const onFormChange = useCallback(
    (value, { name, type }, { setValue, getValues }) => {
      if (type === 'change' && name.includes('sameAsPrimaryUser')) {
        const [slug] = name.split('.');
        if (!!getValues(name)) {
          DISABLED_BY_CHECKBOX.forEach((field) => {
            setValue(`${slug}.value.${field}`, user[USER_FIELD_DEP[field]]);
          });
        } else {
          DISABLED_BY_CHECKBOX.forEach((field) => {
            setValue(`${slug}.value.${field}`, '');
          });
        }
      }
    },
    [user]
  );

  const handleSubmit = useCallback(
    async (form) => {
      await onSubmit(form);
      await questionListQuery.refetch();
    },
    [onSubmit, questionListQuery]
  );

  return payload.questions ? (
    <FormConstructor
      {...props}
      onSubmit={handleSubmit}
      questions={payload.questions}
      answers={payload.answers}
      onFormChange={onFormChange}
      key={formKey}
    />
  ) : (
    <Loader />
  );
};

export default LegalTasks;
